import * as React from "react"

const SvgComponent = (props) => (
    <svg width={512} height={512} {...props} viewBox={'0 0 512 512'}>
        <path fill="#ADAbb9"d="M289 114 152 250v12l137 136 12-12-130-130 130-130z" />
    </svg>
)

export default SvgComponent
